import { useMutation } from '@tanstack/react-query-v4'
import { useApi } from '@api/useApi.hook'
import { QueryKey } from '@api'
import { appConfig } from '@config'
import { queryClient } from '@providers/react-query'

export const useRemoveCartItem = () => {
  const { deleteReq } = useApi()

  return useMutation({
    mutationFn: async (itemId: string): Promise<void> => {
      const endpoint = appConfig.endpoints.v1.cart.itemById.replace(':itemId', itemId)
      await deleteReq<void>(endpoint)()
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.Cart] })
      await queryClient.invalidateQueries({ queryKey: [QueryKey.CartCount] })
    },
  })
}
